import React from "react";
import { NoDataPlaceholder } from "@/icons";
import "./DataLoader.css";

export default function DataLoader() {
    return (
        <div className="data-loader">
            <div className="data-loader__svgWrap">
                <NoDataPlaceholder className="data-loader__svg data-loader__svg--stroke" />
            </div>

            <div className="data-loader__textWrap">
                <div className="data-loader__letters" aria-label="Loading data">
                    {"Loading data".split("").map((ch, i) => (
                        <span key={i} className="data-loader__letter">
              {ch === " " ? "\u00A0" : ch}
            </span>
                    ))}
                </div>
            </div>
        </div>
    );
}
